import { mutator } from 'satcheljs';
import getRecentAttachmentsPillsData from '../selectors/getRecentAttachmentsPillsData';
import { onAttachFailed, onPillAttached } from '../actions/internalActions';
import { AttachmentPillViewStatus } from '../store/schema/AttachmentPillData';

mutator(onAttachFailed, actionMessage => {
    const recentAttachmentsPillsData = getRecentAttachmentsPillsData(actionMessage.composeId);
    if (recentAttachmentsPillsData) {
        const currentPill = recentAttachmentsPillsData.attachmentsPillData.filter(
            pill => pill.attachmentId === actionMessage.attachmentId
        )[0];
        currentPill.attachmentPillViewStatus = AttachmentPillViewStatus.Show;
    }
});

mutator(onPillAttached, actionMessage => {
    const recentAttachmentsPillsData = getRecentAttachmentsPillsData(actionMessage.composeId);
    if (recentAttachmentsPillsData) {
        const currentPill = recentAttachmentsPillsData.attachmentsPillData.filter(
            pill => pill.attachmentId === actionMessage.attachmentId
        )[0];
        currentPill.attachmentPillViewStatus = AttachmentPillViewStatus.Hide;
    }
});
